import React, {memo, useContext, useRef, useState} from "react"
import Lessons from "@/Enums/lessons"
import ResultsContext, {Results} from "@/contexts/ResultsContext";

const Exam: React.FC<{ index: number; name: string; id: string }> = ({
  index,
  name,
  id,
}) => {
  const { results, setResults }: any = useContext(ResultsContext)

  const [released, setReleased] = useState(false)

  const resultInput = useRef<HTMLInputElement | null>(null)

  const resultHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (Number(e.currentTarget.value) > 100) e.currentTarget.value = "100"

    if (e.currentTarget.value.startsWith("-") || e.currentTarget.value === "-")
      e.currentTarget.value = "0"

    let points = 0

    if (released) {
      if (Number(e.currentTarget.value) > 6) e.currentTarget.value = "6"

      if (
        e.currentTarget.value.startsWith("-") ||
        e.currentTarget.value === "-"
      )
        e.currentTarget.value = "0"
      if (id === Lessons.MATH || id === Lessons.POLISH) {
        switch (e.currentTarget.value) {
          case "6":
            points = 35
            break
          case "5":
            points = 30
            break
          case "4":
            points = 25
            break
          case "3":
            points = 15
            break
          case "2":
            points = 10
            break
        }
      } else if (id === Lessons.ALIEN) {
        switch (e.currentTarget.value) {
          case "6":
            points = 30
            break
          case "5":
            points = 25
            break
          case "4":
            points = 20
            break
          case "3":
            points = 10
            break
          case "2":
            points = 5
            break
        }

      }
    } else if (id === Lessons.MATH || id === Lessons.POLISH) {
        points = Math.round(Number(e.currentTarget.value) * 0.35)
    } else if (id === Lessons.ALIEN) {
      points = Math.round(Number(e.currentTarget.value) * 0.3)
    }


    setResults((prevResults: Results) => ({
      ...prevResults,
      exams: {
        ...prevResults.exams,
        [id]: points
      }
    }))
  }

  const releasedHandler = () => {
    if (resultInput.current) {
      resultInput.current.value = ""
      setResults((prevResults: Results) => ({
        ...prevResults,
        exams: {
          ...prevResults.exams,
          [id]: 0
        }
      }))
    }
    setReleased(!released)
  }

  return (
    <div className='w-full flex justify-between gap-4'>
      <label htmlFor={id} className='w-2/4 text-4xl font-medium'>
        {name}
      </label>
      <div className='flex items-center gap-4 text-[1.6rem]'>
        <input
          className='relative text-2xl w-6 h-6 outline-none transition-all duration-300 appearance-none flex content-center justify-center border-[0.3rem] border-btn rounded-full checked:bg-white16'
          id={"zwolniony-" + index + 1}
          type='checkbox'
          onChange={releasedHandler}
        />
        <label htmlFor={"zwolniony-" + index + 1}>zwolniony z egzaminu</label>
      </div>
      <input
        type='number'
        id={id}
        ref={resultInput}
        className='bg-white48 w-40 p-2 rounded-xl text-heading text-center outline-none text-2xl'
        placeholder={released ? "Ocena" : "Wynik (%)"}
        onChange={resultHandler}
      />
      <input
        id={id}
        type='text'
        disabled
        value={results.exams[id]}
        className='bg-white48 w-40 p-1 rounded-xl text-heading text-center outline-none text-3xl points'
      />
    </div>
  )
}

export default memo(Exam)
